import { loadablePage } from 'src/utils/loadable';

export default loadablePage(
  () =>
    import(
      /* webpackChunkName: "PurchaseFlowModal" */ /* webpackPrefetch: true */
      './StepSelectTemplatesModal.component'
    ),
);
